import { createGlobalStyle } from 'styled-components';
import generalStyleCore from './general/generalStyleCore';
import generalStyleFeed from './general/generalStyleFeed';
import generalStyleCompany from './general/generalStyleCompany';
import generalStyleSearch from './general/generalStyleSearch';
import generalStylePerson from './general/generalStylePerson';
import generalStylePeople from './general/generalStylePeople';
import generalStyleNews from './general/generalStyleNews';
import generalStyleHighlights from './general/generalStyleHighlights';

/**
 * Composed from domain modules under ./general/ — same CSS output as the
 * monolithic file, split only for maintainability. All parts stay loaded
 * globally to avoid route-level cascade regressions.
 */
const GeneralStyle = createGlobalStyle`
  ${generalStyleCore}
  ${generalStyleFeed}
  ${generalStyleCompany}
  ${generalStyleSearch}
  ${generalStylePerson}
  ${generalStylePeople}
  ${generalStyleNews}
  ${generalStyleHighlights}
`;

export default GeneralStyle;
